import { forwardRef, type CSSProperties, type HTMLAttributes, type ReactNode } from "react";

import { themeVars, type ThemeMode, type ThemeSurface, type ThemeSystem } from "./themes.js";

export type ThemeScopeProps = HTMLAttributes<HTMLDivElement> & {
  readonly surface: ThemeSurface;
  readonly system: ThemeSystem;
  readonly mode: ThemeMode;
  readonly overrides?: Readonly<Record<string, string>> | undefined;
  readonly children: ReactNode;
};

export const ThemeScope = forwardRef<HTMLDivElement, ThemeScopeProps>(function ThemeScope(
  { surface, system, mode, overrides, className, style, children, ...rest },
  ref,
) {
  const painted: CSSProperties = {
    ...themeVars(surface, system, mode, overrides),
    ...style,
  };
  return (
    <div ref={ref} className={className} style={painted} {...rest}>
      {children}
    </div>
  );
});
